import React, { useRef } from "react";
import Img_3 from "../../assets/auth/admindashboardimg3.png";
import Img_logo from "../../assets/auth/logo.png";
import Reset_Password from "../../assets/auth/reset-password.png";
import Close_Button from "../../assets/auth/close.png";
import Styles from "../../styles/admin/login.module.scss";
import { resetGymPasswordService } from "../../services";
import { useNavigate, useParams } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import Swal from "sweetalert2";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  let passwordRef = useRef("");
  let cpasswordRef = useRef("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (true) {
      const success = await resetGymPasswordService(
        token,
        passwordRef.current.value,
        cpasswordRef.current.value
      );
      if (success) {
        Swal.fire({
          html: `
      <div style="text-align: center; border-radius: 20px; position: relative; font-family: 'gothambold', sans-serif;">
      <button 
        id="customCloseButton" 
        style="position: absolute; top: -10px; right: -20px; background: none; border: none; cursor: pointer;">
        <img 
          src=${Close_Button} 
          alt="Close" 
          style="width: 50px; height: 50px;"
        />
      </button>
      <img 
        src=${Reset_Password} 
        alt="Success" 
        style="width: 100px; margin-bottom: 20px; margin-top: 30px;" 
      />
      <h2 style="margin: 0; font-family: 'gothambold', sans-serif;">Password Changed!</h2>
            <br/>
      <p style="font-family: 'Gotham Book', sans-serif;">
        You’ve successfully completed your password reset.
      </p>
      <br/>
      <button 
        id="okButton" 
        style="
          background: linear-gradient(0deg, #151515 0%, #525252 100%); 
          color: #f3f3f6; 
          padding: 10px 30px; 
          border: none; 
          border-radius: 5px; 
          cursor: pointer; 
          margin-top: 20px; 
          font-family: 'gothambold', sans-serif;
        ">
        Login Now
      </button>
    </div>
        `,
          showConfirmButton: false,
          customClass: {
            popup: "custom-swal-container",
          },
          didOpen: () => {
            const thanksButton = document.getElementById("okButton");
            thanksButton.addEventListener("click", () => {
              Swal.close();
              navigate(adminRoutes.login);
            });
          },
        });
      }
    }
  };
  return (
    <div className={Styles.dashboard_main}>
      <div className={Styles.dashboard_flexmain}>
        <div className={Styles.flexdivider_1}>
          <img src={Img_3} alt="admin_dash_img1" />
        </div>
        <div className={Styles.flexdivider_2}>
          <div className={Styles.flexdivider_2_logo}>
            <img src={Img_logo} alt="admin_dash_logo" />
          </div>

          <div className={Styles.flexdivider_2_formcontainer}>
            <form autoComplete="" onSubmit={handleSubmit}>
              <div className={Styles.flexdivider_2_formcontainer_username}>
                <label className={Styles.label}>Enter New Password</label>
                <input
                  placeholder="Enter here"
                  type="password"
                  name="password"
                  minLength={2}
                  maxLength={50}
                  ref={passwordRef}
                />
              </div>
              <div className={Styles.flexdivider_2_formcontainer_username}>
                <label className={Styles.label}>Re Enter New Password</label>
                <input
                  placeholder="Enter here"
                  type="password"
                  name="password"
                  minLength={2}
                  maxLength={50}
                  ref={cpasswordRef}
                />
              </div>
              <div className={Styles.flexdivider_2_formcontainer_button}>
                <button type="submit">
                  {" "}
                  <span>SUBMIT</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
